import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

export default class ErrorItem extends React.Component {
  constructor(props) {
    super(props);

    this.clickCloseHandler = this.clickCloseHandler.bind(this);
  }

  clickCloseHandler(evt) {
    const { onClickClose, data } = this.props;
    if (onClickClose) {
      onClickClose(data, this, evt);
    }
  }

  render() {
    const { message, className } = this.props;
    const resultClassName = classnames(
      'configurator__error-item',
      className,
    );
    return (
      <div className={resultClassName}>
        <span className="icon icon-left icon-warning" />
        <FormattedMessage id={message} />
        <span
          role="button"
          onClick={this.clickCloseHandler}
          className="icon icon-right icon-close-circle"
        />
      </div>
    );
  }
}

ErrorItem.propTypes = {
  data: PropTypes.any,
  message: PropTypes.string,
  className: PropTypes.string,
  onClickClose: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/components/configuration/error-list/error-item.jsx